<template>
  <div>
    <!-- <k-line :id="1"></k-line> -->
    <iframe height="580" width="560"
        src="https://ssltvc.investing.com/?pair_ID=8832&height=480&width=650&interval=300&plotStyle=area&domain_ID=6&lang_ID=6&timezone_ID=0"></iframe>
  </div>
</template>

<script>
import KLine from '../../components/kline/KLine.vue'
// import te from '../../tools/tradingeconomics'

export default {
  components: { KLine },
  name: 'TestKLine',
  data () {
    return {

    }
  },
  methods: {

  },
  mounted () {
    // console.log(te);
  },
  setup () {
    return {

    }
  }
}
</script>

<style  lang="scss" scoped>

</style>
